var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.562,
    height: 20.562,
    viewBox: "0 0 20.562 20.562",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2064",
    "data-name": "Caminho 2064",
    d: "M18.152,0H2.41A2.412,2.412,0,0,0,0,2.41V18.152a2.412,2.412,0,0,0,2.41,2.41H18.152a2.412,2.412,0,0,0,2.41-2.41V2.41A2.412,2.412,0,0,0,18.152,0Zm.8,18.152a.8.8,0,0,1-.8.8H13.574V12.409h2.481l.41-2.49H13.574V8.193a1.184,1.184,0,0,1,1.2-1.2h1.647V4.5H14.779a3.694,3.694,0,0,0-3.694,3.7v1.72H8.675v2.49h2.41v6.546H2.41a.8.8,0,0,1-.8-.8V2.41a.8.8,0,0,1,.8-.8H18.152a.8.8,0,0,1,.8.8Z",
    fill: "#63799b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.41502eb6d6d1230c1787ec6df9027a42.svg";
export { ForwardRef as ReactComponent };